var map = {
	"./Caissa/Caissa_bot_girl.svg": "./src/Assets/Images/Caissa/Caissa_bot_girl.svg",
	"./Caissa/Caissa_bot_horse.svg": "./src/Assets/Images/Caissa/Caissa_bot_horse.svg",
	"./Caissa/PlayAndLearnTabPatternMobile.svg": "./src/Assets/Images/Caissa/PlayAndLearnTabPatternMobile.svg",
	"./Caissa/PlayModeIcon.svg": "./src/Assets/Images/Caissa/PlayModeIcon.svg",
	"./Caissa/TournamenTab.svg": "./src/Assets/Images/Caissa/TournamenTab.svg",
	"./Caissa/aqua_chess_pattern.svg": "./src/Assets/Images/Caissa/aqua_chess_pattern.svg",
	"./Caissa/chatbot/Parental_control_rules.svg": "./src/Assets/Images/Caissa/chatbot/Parental_control_rules.svg",
	"./Caissa/chatbot/chessboard_stairs_chatbot_bg.svg": "./src/Assets/Images/Caissa/chatbot/chessboard_stairs_chatbot_bg.svg",
	"./ChessPieces/Black-Rook.png": "./src/Assets/Images/ChessPieces/Black-Rook.png",
	"./ChessPieces/Black-Rook.svg": "./src/Assets/Images/ChessPieces/Black-Rook.svg",
	"./ChessPieces/White-Rook.png": "./src/Assets/Images/ChessPieces/White-Rook.png",
	"./ChessPieces/White-Rook.svg": "./src/Assets/Images/ChessPieces/White-Rook.svg",
	"./ChessPieces/whiterookscale.svg": "./src/Assets/Images/ChessPieces/whiterookscale.svg",
	"./Help/Classroom/permissions.png": "./src/Assets/Images/Help/Classroom/permissions.png",
	"./Meetings/Coach.svg": "./src/Assets/Images/Meetings/Coach.svg",
	"./Meetings/Instructor.svg": "./src/Assets/Images/Meetings/Instructor.svg",
	"./Meetings/Mentor.svg": "./src/Assets/Images/Meetings/Mentor.svg",
	"./Meetings/Pattern.svg": "./src/Assets/Images/Meetings/Pattern.svg",
	"./Meetings/Practice.svg": "./src/Assets/Images/Meetings/Practice.svg",
	"./Meetings/csoc_expiry_icon.svg": "./src/Assets/Images/Meetings/csoc_expiry_icon.svg",
	"./Meetings/csoc_plan_expiring.svg": "./src/Assets/Images/Meetings/csoc_plan_expiring.svg",
	"./Otb/card_pattern.svg": "./src/Assets/Images/Otb/card_pattern.svg",
	"./Otb/corner_pattern.svg": "./src/Assets/Images/Otb/corner_pattern.svg",
	"./Otb/otb_image.svg": "./src/Assets/Images/Otb/otb_image.svg",
	"./PlayerProfile/assessment.svg": "./src/Assets/Images/PlayerProfile/assessment.svg",
	"./PlayerProfile/bronzeMedal.svg": "./src/Assets/Images/PlayerProfile/bronzeMedal.svg",
	"./PlayerProfile/caissa-girl.svg": "./src/Assets/Images/PlayerProfile/caissa-girl.svg",
	"./PlayerProfile/cc-icon.svg": "./src/Assets/Images/PlayerProfile/cc-icon.svg",
	"./PlayerProfile/coin.svg": "./src/Assets/Images/PlayerProfile/coin.svg",
	"./PlayerProfile/four_squares.svg": "./src/Assets/Images/PlayerProfile/four_squares.svg",
	"./PlayerProfile/game_analytics.svg": "./src/Assets/Images/PlayerProfile/game_analytics.svg",
	"./PlayerProfile/goldMedal.svg": "./src/Assets/Images/PlayerProfile/goldMedal.svg",
	"./PlayerProfile/pattern.svg": "./src/Assets/Images/PlayerProfile/pattern.svg",
	"./PlayerProfile/silverMedal.svg": "./src/Assets/Images/PlayerProfile/silverMedal.svg",
	"./PlayerProfile/tournament.svg": "./src/Assets/Images/PlayerProfile/tournament.svg",
	"./Points/negativePoint.png": "./src/Assets/Images/Points/negativePoint.png",
	"./Points/positivePoint.png": "./src/Assets/Images/Points/positivePoint.png",
	"./RequestAccess/NoPlayer.svg": "./src/Assets/Images/RequestAccess/NoPlayer.svg",
	"./ReviewGame.png": "./src/Assets/Images/ReviewGame.png",
	"./Rules-image.png": "./src/Assets/Images/Rules-image.png",
	"./Svgs/14_days_renew_icon.svg": "./src/Assets/Images/Svgs/14_days_renew_icon.svg",
	"./Svgs/BeginnerDashboard/Background.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/Background.svg",
	"./Svgs/BeginnerDashboard/BrightChampsLogo.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/BrightChampsLogo.svg",
	"./Svgs/BeginnerDashboard/Chessboard.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/Chessboard.svg",
	"./Svgs/BeginnerDashboard/FindSquare.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/FindSquare.svg",
	"./Svgs/BeginnerDashboard/GirlMathIcon.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/GirlMathIcon.svg",
	"./Svgs/BeginnerDashboard/GirlMathIconMobile.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/GirlMathIconMobile.svg",
	"./Svgs/BeginnerDashboard/Intersect.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/Intersect.svg",
	"./Svgs/BeginnerDashboard/IntersectPattern.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/IntersectPattern.svg",
	"./Svgs/BeginnerDashboard/LearningRoadmap.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/LearningRoadmap.svg",
	"./Svgs/BeginnerDashboard/PlayAGame.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/PlayAGame.svg",
	"./Svgs/BeginnerDashboard/PracticePosition.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/PracticePosition.svg",
	"./Svgs/BeginnerDashboard/pawnIcon.svg": "./src/Assets/Images/Svgs/BeginnerDashboard/pawnIcon.svg",
	"./Svgs/Bolt.svg": "./src/Assets/Images/Svgs/Bolt.svg",
	"./Svgs/Bullet.svg": "./src/Assets/Images/Svgs/Bullet.svg",
	"./Svgs/CCCurrency": "./src/Assets/Images/Svgs/CCCurrency.tsx",
	"./Svgs/CCCurrency.tsx": "./src/Assets/Images/Svgs/CCCurrency.tsx",
	"./Svgs/CCTicketIcon": "./src/Assets/Images/Svgs/CCTicketIcon.tsx",
	"./Svgs/CCTicketIcon.tsx": "./src/Assets/Images/Svgs/CCTicketIcon.tsx",
	"./Svgs/Ellipse.svg": "./src/Assets/Images/Svgs/Ellipse.svg",
	"./Svgs/ExclamationIcon": "./src/Assets/Images/Svgs/ExclamationIcon.tsx",
	"./Svgs/ExclamationIcon.tsx": "./src/Assets/Images/Svgs/ExclamationIcon.tsx",
	"./Svgs/IncorrectMove.svg": "./src/Assets/Images/Svgs/IncorrectMove.svg",
	"./Svgs/IsOngoing.svg": "./src/Assets/Images/Svgs/IsOngoing.svg",
	"./Svgs/LeagueDetail.svg": "./src/Assets/Images/Svgs/LeagueDetail.svg",
	"./Svgs/Parental_control_rules.svg": "./src/Assets/Images/Svgs/Parental_control_rules.svg",
	"./Svgs/Payments/rupay.svg": "./src/Assets/Images/Svgs/Payments/rupay.svg",
	"./Svgs/Play active.svg": "./src/Assets/Images/Svgs/Play active.svg",
	"./Svgs/Play and Learn active.svg": "./src/Assets/Images/Svgs/Play and Learn active.svg",
	"./Svgs/Play and Learn normal.svg": "./src/Assets/Images/Svgs/Play and Learn normal.svg",
	"./Svgs/Play normal.svg": "./src/Assets/Images/Svgs/Play normal.svg",
	"./Svgs/Play.svg": "./src/Assets/Images/Svgs/Play.svg",
	"./Svgs/Play_from_any_position.svg": "./src/Assets/Images/Svgs/Play_from_any_position.svg",
	"./Svgs/PlayandLearn.svg": "./src/Assets/Images/Svgs/PlayandLearn.svg",
	"./Svgs/Rapid.svg": "./src/Assets/Images/Svgs/Rapid.svg",
	"./Svgs/Rectangle.svg": "./src/Assets/Images/Svgs/Rectangle.svg",
	"./Svgs/Snail.svg": "./src/Assets/Images/Svgs/Snail.svg",
	"./Svgs/Summary.svg": "./src/Assets/Images/Svgs/Summary.svg",
	"./Svgs/Tournaments.svg": "./src/Assets/Images/Svgs/Tournaments.svg",
	"./Svgs/addMember.svg": "./src/Assets/Images/Svgs/addMember.svg",
	"./Svgs/androidqr.jpg": "./src/Assets/Images/Svgs/androidqr.jpg",
	"./Svgs/appModalImage.jpg": "./src/Assets/Images/Svgs/appModalImage.jpg",
	"./Svgs/background_frames.svg": "./src/Assets/Images/Svgs/background_frames.svg",
	"./Svgs/bannerItems/header1.png": "./src/Assets/Images/Svgs/bannerItems/header1.png",
	"./Svgs/bannerItems/header2.png": "./src/Assets/Images/Svgs/bannerItems/header2.png",
	"./Svgs/bannerItems/header3.png": "./src/Assets/Images/Svgs/bannerItems/header3.png",
	"./Svgs/bannerItems/left.png": "./src/Assets/Images/Svgs/bannerItems/left.png",
	"./Svgs/bannerItems/right.png": "./src/Assets/Images/Svgs/bannerItems/right.png",
	"./Svgs/bannerItems/topHeader.png": "./src/Assets/Images/Svgs/bannerItems/topHeader.png",
	"./Svgs/bannerchakra.svg": "./src/Assets/Images/Svgs/bannerchakra.svg",
	"./Svgs/beginIg.svg": "./src/Assets/Images/Svgs/beginIg.svg",
	"./Svgs/blue-chessboard.jpg": "./src/Assets/Images/Svgs/blue-chessboard.jpg",
	"./Svgs/blue.svg": "./src/Assets/Images/Svgs/blue.svg",
	"./Svgs/book-check.svg": "./src/Assets/Images/Svgs/book-check.svg",
	"./Svgs/book-open.svg": "./src/Assets/Images/Svgs/book-open.svg",
	"./Svgs/bottomShadow.svg": "./src/Assets/Images/Svgs/bottomShadow.svg",
	"./Svgs/bottombg.svg": "./src/Assets/Images/Svgs/bottombg.svg",
	"./Svgs/brief_logo.png": "./src/Assets/Images/Svgs/brief_logo.png",
	"./Svgs/bronzeMedal.svg": "./src/Assets/Images/Svgs/bronzeMedal.svg",
	"./Svgs/brownleft.svg": "./src/Assets/Images/Svgs/brownleft.svg",
	"./Svgs/brownright.svg": "./src/Assets/Images/Svgs/brownright.svg",
	"./Svgs/caissaAvatar.svg": "./src/Assets/Images/Svgs/caissaAvatar.svg",
	"./Svgs/callBgPattern.svg": "./src/Assets/Images/Svgs/callBgPattern.svg",
	"./Svgs/cameraPlus.svg": "./src/Assets/Images/Svgs/cameraPlus.svg",
	"./Svgs/cc-logo-dark.svg": "./src/Assets/Images/Svgs/cc-logo-dark.svg",
	"./Svgs/cc-logo-light.svg": "./src/Assets/Images/Svgs/cc-logo-light.svg",
	"./Svgs/ccIcon.svg": "./src/Assets/Images/Svgs/ccIcon.svg",
	"./Svgs/cc_logo.png": "./src/Assets/Images/Svgs/cc_logo.png",
	"./Svgs/cc_logo_dark.svg": "./src/Assets/Images/Svgs/cc_logo_dark.svg",
	"./Svgs/cc_logo_light.svg": "./src/Assets/Images/Svgs/cc_logo_light.svg",
	"./Svgs/ccleague.svg": "./src/Assets/Images/Svgs/ccleague.svg",
	"./Svgs/challengehover.svg": "./src/Assets/Images/Svgs/challengehover.svg",
	"./Svgs/chatLogo.svg": "./src/Assets/Images/Svgs/chatLogo.svg",
	"./Svgs/checksquare.svg": "./src/Assets/Images/Svgs/checksquare.svg",
	"./Svgs/chess_pieces.svg": "./src/Assets/Images/Svgs/chess_pieces.svg",
	"./Svgs/chessboard.svg": "./src/Assets/Images/Svgs/chessboard.svg",
	"./Svgs/chesscom-mark.svg": "./src/Assets/Images/Svgs/chesscom-mark.svg",
	"./Svgs/chesscom.png": "./src/Assets/Images/Svgs/chesscom.png",
	"./Svgs/chessdotcom.svg": "./src/Assets/Images/Svgs/chessdotcom.svg",
	"./Svgs/chevronDoubleDown.svg": "./src/Assets/Images/Svgs/chevronDoubleDown.svg",
	"./Svgs/chevronDoubleUp.svg": "./src/Assets/Images/Svgs/chevronDoubleUp.svg",
	"./Svgs/circle_chess_back_half.png": "./src/Assets/Images/Svgs/circle_chess_back_half.png",
	"./Svgs/coinBackgoundForGoals.svg": "./src/Assets/Images/Svgs/coinBackgoundForGoals.svg",
	"./Svgs/coinInRewards.svg": "./src/Assets/Images/Svgs/coinInRewards.svg",
	"./Svgs/coming_soon.png": "./src/Assets/Images/Svgs/coming_soon.png",
	"./Svgs/coming_soon_2.png": "./src/Assets/Images/Svgs/coming_soon_2.png",
	"./Svgs/congrats.svg": "./src/Assets/Images/Svgs/congrats.svg",
	"./Svgs/connection_change.svg": "./src/Assets/Images/Svgs/connection_change.svg",
	"./Svgs/correct.svg": "./src/Assets/Images/Svgs/correct.svg",
	"./Svgs/crossCircle.svg": "./src/Assets/Images/Svgs/crossCircle.svg",
	"./Svgs/cursorclick.svg": "./src/Assets/Images/Svgs/cursorclick.svg",
	"./Svgs/custom_positions_tournaments.svg": "./src/Assets/Images/Svgs/custom_positions_tournaments.svg",
	"./Svgs/download.svg": "./src/Assets/Images/Svgs/download.svg",
	"./Svgs/endgamewhite.svg": "./src/Assets/Images/Svgs/endgamewhite.svg",
	"./Svgs/euros.svg": "./src/Assets/Images/Svgs/euros.svg",
	"./Svgs/expert_cheat_detection.svg": "./src/Assets/Images/Svgs/expert_cheat_detection.svg",
	"./Svgs/expired_svg_renewal_icon.svg": "./src/Assets/Images/Svgs/expired_svg_renewal_icon.svg",
	"./Svgs/fully_private_games.svg": "./src/Assets/Images/Svgs/fully_private_games.svg",
	"./Svgs/gameplay_assistant.svg": "./src/Assets/Images/Svgs/gameplay_assistant.svg",
	"./Svgs/giftIcon.svg": "./src/Assets/Images/Svgs/giftIcon.svg",
	"./Svgs/gm-elisabeth.svg": "./src/Assets/Images/Svgs/gm-elisabeth.svg",
	"./Svgs/gm-shardul-gagare.svg": "./src/Assets/Images/Svgs/gm-shardul-gagare.svg",
	"./Svgs/goldMedal.svg": "./src/Assets/Images/Svgs/goldMedal.svg",
	"./Svgs/green-chessboard.jpg": "./src/Assets/Images/Svgs/green-chessboard.jpg",
	"./Svgs/green.svg": "./src/Assets/Images/Svgs/green.svg",
	"./Svgs/greycircle.svg": "./src/Assets/Images/Svgs/greycircle.svg",
	"./Svgs/hint.svg": "./src/Assets/Images/Svgs/hint.svg",
	"./Svgs/home_page/AI-enabled Caissa.svg": "./src/Assets/Images/Svgs/home_page/AI-enabled Caissa.svg",
	"./Svgs/home_page/Frame.svg": "./src/Assets/Images/Svgs/home_page/Frame.svg",
	"./Svgs/home_page/Frame1.svg": "./src/Assets/Images/Svgs/home_page/Frame1.svg",
	"./Svgs/home_page/Frame2.svg": "./src/Assets/Images/Svgs/home_page/Frame2.svg",
	"./Svgs/home_page/Frame3.svg": "./src/Assets/Images/Svgs/home_page/Frame3.svg",
	"./Svgs/home_page/PRO.svg": "./src/Assets/Images/Svgs/home_page/PRO.svg",
	"./Svgs/home_page/Union.svg": "./src/Assets/Images/Svgs/home_page/Union.svg",
	"./Svgs/home_page/arrow_down.svg": "./src/Assets/Images/Svgs/home_page/arrow_down.svg",
	"./Svgs/home_page/arrow_up.svg": "./src/Assets/Images/Svgs/home_page/arrow_up.svg",
	"./Svgs/home_page/assessment.svg": "./src/Assets/Images/Svgs/home_page/assessment.svg",
	"./Svgs/home_page/badge.svg": "./src/Assets/Images/Svgs/home_page/badge.svg",
	"./Svgs/home_page/beginners_curve.svg": "./src/Assets/Images/Svgs/home_page/beginners_curve.svg",
	"./Svgs/home_page/books_videos.svg": "./src/Assets/Images/Svgs/home_page/books_videos.svg",
	"./Svgs/home_page/bottomLeftSquare.svg": "./src/Assets/Images/Svgs/home_page/bottomLeftSquare.svg",
	"./Svgs/home_page/bottomRightSquare.svg": "./src/Assets/Images/Svgs/home_page/bottomRightSquare.svg",
	"./Svgs/home_page/caissa.svg": "./src/Assets/Images/Svgs/home_page/caissa.svg",
	"./Svgs/home_page/calculation_trainer.svg": "./src/Assets/Images/Svgs/home_page/calculation_trainer.svg",
	"./Svgs/home_page/chat.svg": "./src/Assets/Images/Svgs/home_page/chat.svg",
	"./Svgs/home_page/chess_events.svg": "./src/Assets/Images/Svgs/home_page/chess_events.svg",
	"./Svgs/home_page/chessboard_left_part_large.svg": "./src/Assets/Images/Svgs/home_page/chessboard_left_part_large.svg",
	"./Svgs/home_page/chessboard_part_left.svg": "./src/Assets/Images/Svgs/home_page/chessboard_part_left.svg",
	"./Svgs/home_page/chessboard_part_right.svg": "./src/Assets/Images/Svgs/home_page/chessboard_part_right.svg",
	"./Svgs/home_page/chessboard_right_part_large.svg": "./src/Assets/Images/Svgs/home_page/chessboard_right_part_large.svg",
	"./Svgs/home_page/cropped_dashboard.svg": "./src/Assets/Images/Svgs/home_page/cropped_dashboard.svg",
	"./Svgs/home_page/double_arrow_up.svg": "./src/Assets/Images/Svgs/home_page/double_arrow_up.svg",
	"./Svgs/home_page/four_squares.svg": "./src/Assets/Images/Svgs/home_page/four_squares.svg",
	"./Svgs/home_page/game_analytics.svg": "./src/Assets/Images/Svgs/home_page/game_analytics.svg",
	"./Svgs/home_page/game_play.svg": "./src/Assets/Images/Svgs/home_page/game_play.svg",
	"./Svgs/home_page/intermediate.svg": "./src/Assets/Images/Svgs/home_page/intermediate.svg",
	"./Svgs/home_page/intuition_trainer.svg": "./src/Assets/Images/Svgs/home_page/intuition_trainer.svg",
	"./Svgs/home_page/learning.svg": "./src/Assets/Images/Svgs/home_page/learning.svg",
	"./Svgs/home_page/logo.svg": "./src/Assets/Images/Svgs/home_page/logo.svg",
	"./Svgs/home_page/organisation_trophy.svg": "./src/Assets/Images/Svgs/home_page/organisation_trophy.svg",
	"./Svgs/home_page/parental_control.svg": "./src/Assets/Images/Svgs/home_page/parental_control.svg",
	"./Svgs/home_page/play.svg": "./src/Assets/Images/Svgs/home_page/play.svg",
	"./Svgs/home_page/player.svg": "./src/Assets/Images/Svgs/home_page/player.svg",
	"./Svgs/home_page/positions_trainer.svg": "./src/Assets/Images/Svgs/home_page/positions_trainer.svg",
	"./Svgs/home_page/review.svg": "./src/Assets/Images/Svgs/home_page/review.svg",
	"./Svgs/home_page/rules.svg": "./src/Assets/Images/Svgs/home_page/rules.svg",
	"./Svgs/home_page/signup_assess.svg": "./src/Assets/Images/Svgs/home_page/signup_assess.svg",
	"./Svgs/home_page/signup_elevate.svg": "./src/Assets/Images/Svgs/home_page/signup_elevate.svg",
	"./Svgs/home_page/square.svg": "./src/Assets/Images/Svgs/home_page/square.svg",
	"./Svgs/home_page/square_background.svg": "./src/Assets/Images/Svgs/home_page/square_background.svg",
	"./Svgs/home_page/sync_obt.svg": "./src/Assets/Images/Svgs/home_page/sync_obt.svg",
	"./Svgs/home_page/tournament.svg": "./src/Assets/Images/Svgs/home_page/tournament.svg",
	"./Svgs/home_page/two_squares.svg": "./src/Assets/Images/Svgs/home_page/two_squares.svg",
	"./Svgs/iosqr.jpg": "./src/Assets/Images/Svgs/iosqr.jpg",
	"./Svgs/knights_elephant.png": "./src/Assets/Images/Svgs/knights_elephant.png",
	"./Svgs/largest_learning_community.svg": "./src/Assets/Images/Svgs/largest_learning_community.svg",
	"./Svgs/leagueBackground.svg": "./src/Assets/Images/Svgs/leagueBackground.svg",
	"./Svgs/learning/arrow.svg": "./src/Assets/Images/Svgs/learning/arrow.svg",
	"./Svgs/learning/assessment.svg": "./src/Assets/Images/Svgs/learning/assessment.svg",
	"./Svgs/learning/blunder-icon.svg": "./src/Assets/Images/Svgs/learning/blunder-icon.svg",
	"./Svgs/learning/gamified-experience.svg": "./src/Assets/Images/Svgs/learning/gamified-experience.svg",
	"./Svgs/learning/inaccuracy-icon.svg": "./src/Assets/Images/Svgs/learning/inaccuracy-icon.svg",
	"./Svgs/learning/master-games.svg": "./src/Assets/Images/Svgs/learning/master-games.svg",
	"./Svgs/learning/mistakes-icon.svg": "./src/Assets/Images/Svgs/learning/mistakes-icon.svg",
	"./Svgs/learning/personalized-content.svg": "./src/Assets/Images/Svgs/learning/personalized-content.svg",
	"./Svgs/learning/slash.svg": "./src/Assets/Images/Svgs/learning/slash.svg",
	"./Svgs/left.svg": "./src/Assets/Images/Svgs/left.svg",
	"./Svgs/leftbackground.svg": "./src/Assets/Images/Svgs/leftbackground.svg",
	"./Svgs/levelUnitEmpty.svg": "./src/Assets/Images/Svgs/levelUnitEmpty.svg",
	"./Svgs/levelUnitEmptyBrown.svg": "./src/Assets/Images/Svgs/levelUnitEmptyBrown.svg",
	"./Svgs/levelUnitFilled.svg": "./src/Assets/Images/Svgs/levelUnitFilled.svg",
	"./Svgs/levelUnitFilledBrown.svg": "./src/Assets/Images/Svgs/levelUnitFilledBrown.svg",
	"./Svgs/lichess.png": "./src/Assets/Images/Svgs/lichess.png",
	"./Svgs/lichess.svg": "./src/Assets/Images/Svgs/lichess.svg",
	"./Svgs/lichess_knight.svg": "./src/Assets/Images/Svgs/lichess_knight.svg",
	"./Svgs/login_side_pattern.svg": "./src/Assets/Images/Svgs/login_side_pattern.svg",
	"./Svgs/logo.svg": "./src/Assets/Images/Svgs/logo.svg",
	"./Svgs/logo/logo.svg": "./src/Assets/Images/Svgs/logo/logo.svg",
	"./Svgs/logoicon.svg": "./src/Assets/Images/Svgs/logoicon.svg",
	"./Svgs/loseBattleIcon.svg": "./src/Assets/Images/Svgs/loseBattleIcon.svg",
	"./Svgs/mainappbanner.jpg": "./src/Assets/Images/Svgs/mainappbanner.jpg",
	"./Svgs/message-chat-circle.svg": "./src/Assets/Images/Svgs/message-chat-circle.svg",
	"./Svgs/message.svg": "./src/Assets/Images/Svgs/message.svg",
	"./Svgs/middle.svg": "./src/Assets/Images/Svgs/middle.svg",
	"./Svgs/mobile_bg.svg": "./src/Assets/Images/Svgs/mobile_bg.svg",
	"./Svgs/mobile_corner_prize.svg": "./src/Assets/Images/Svgs/mobile_corner_prize.svg",
	"./Svgs/new_book_icon.svg": "./src/Assets/Images/Svgs/new_book_icon.svg",
	"./Svgs/no_issue_selected.svg": "./src/Assets/Images/Svgs/no_issue_selected.svg",
	"./Svgs/pattern.svg": "./src/Assets/Images/Svgs/pattern.svg",
	"./Svgs/pawnpair.svg": "./src/Assets/Images/Svgs/pawnpair.svg",
	"./Svgs/pawns.svg": "./src/Assets/Images/Svgs/pawns.svg",
	"./Svgs/peopleGroup.svg": "./src/Assets/Images/Svgs/peopleGroup.svg",
	"./Svgs/person_playing_chess.svg": "./src/Assets/Images/Svgs/person_playing_chess.svg",
	"./Svgs/phoneCall copy.svg": "./src/Assets/Images/Svgs/phoneCall copy.svg",
	"./Svgs/phoneCall.svg": "./src/Assets/Images/Svgs/phoneCall.svg",
	"./Svgs/pink.svg": "./src/Assets/Images/Svgs/pink.svg",
	"./Svgs/playerSelected.svg": "./src/Assets/Images/Svgs/playerSelected.svg",
	"./Svgs/playstore.svg": "./src/Assets/Images/Svgs/playstore.svg",
	"./Svgs/points.svg": "./src/Assets/Images/Svgs/points.svg",
	"./Svgs/pointsCoinIcon.svg": "./src/Assets/Images/Svgs/pointsCoinIcon.svg",
	"./Svgs/postionTrainerBattle.svg": "./src/Assets/Images/Svgs/postionTrainerBattle.svg",
	"./Svgs/prize.svg": "./src/Assets/Images/Svgs/prize.svg",
	"./Svgs/prizeapp.svg": "./src/Assets/Images/Svgs/prizeapp.svg",
	"./Svgs/prizereminder.svg": "./src/Assets/Images/Svgs/prizereminder.svg",
	"./Svgs/proIg.svg": "./src/Assets/Images/Svgs/proIg.svg",
	"./Svgs/purple.svg": "./src/Assets/Images/Svgs/purple.svg",
	"./Svgs/puzzleDashChallenge.svg": "./src/Assets/Images/Svgs/puzzleDashChallenge.svg",
	"./Svgs/puzzleRoyaleChallenge.svg": "./src/Assets/Images/Svgs/puzzleRoyaleChallenge.svg",
	"./Svgs/puzzle_attempts.svg": "./src/Assets/Images/Svgs/puzzle_attempts.svg",
	"./Svgs/puzzle_timer.svg": "./src/Assets/Images/Svgs/puzzle_timer.svg",
	"./Svgs/quote.png": "./src/Assets/Images/Svgs/quote.png",
	"./Svgs/rectangles.svg": "./src/Assets/Images/Svgs/rectangles.svg",
	"./Svgs/reflects_your_rating.svg": "./src/Assets/Images/Svgs/reflects_your_rating.svg",
	"./Svgs/right.svg": "./src/Assets/Images/Svgs/right.svg",
	"./Svgs/select_avatar.svg": "./src/Assets/Images/Svgs/select_avatar.svg",
	"./Svgs/silhouette-male-icon.svg": "./src/Assets/Images/Svgs/silhouette-male-icon.svg",
	"./Svgs/silverMedal.svg": "./src/Assets/Images/Svgs/silverMedal.svg",
	"./Svgs/singular_ecosystem.svg": "./src/Assets/Images/Svgs/singular_ecosystem.svg",
	"./Svgs/speedometer.svg": "./src/Assets/Images/Svgs/speedometer.svg",
	"./Svgs/squareTrainerChallenge.svg": "./src/Assets/Images/Svgs/squareTrainerChallenge.svg",
	"./Svgs/squares.svg": "./src/Assets/Images/Svgs/squares.svg",
	"./Svgs/thumsdown.svg": "./src/Assets/Images/Svgs/thumsdown.svg",
	"./Svgs/thumsdownActive.svg": "./src/Assets/Images/Svgs/thumsdownActive.svg",
	"./Svgs/thumsup.svg": "./src/Assets/Images/Svgs/thumsup.svg",
	"./Svgs/thumsupActive.svg": "./src/Assets/Images/Svgs/thumsupActive.svg",
	"./Svgs/toprightbg.svg": "./src/Assets/Images/Svgs/toprightbg.svg",
	"./Svgs/tournament_banner/Union.svg": "./src/Assets/Images/Svgs/tournament_banner/Union.svg",
	"./Svgs/tournament_banner/background_pattern.svg": "./src/Assets/Images/Svgs/tournament_banner/background_pattern.svg",
	"./Svgs/tournament_banner/background_pattern_mobile.svg": "./src/Assets/Images/Svgs/tournament_banner/background_pattern_mobile.svg",
	"./Svgs/tournament_banner/bannerMain.svg": "./src/Assets/Images/Svgs/tournament_banner/bannerMain.svg",
	"./Svgs/tournament_banner/banner_main.svg": "./src/Assets/Images/Svgs/tournament_banner/banner_main.svg",
	"./Svgs/tournament_banner/bg_pattern.svg": "./src/Assets/Images/Svgs/tournament_banner/bg_pattern.svg",
	"./Svgs/tournament_banner/black_bg_pattern.svg": "./src/Assets/Images/Svgs/tournament_banner/black_bg_pattern.svg",
	"./Svgs/tournament_banner/calendar.svg": "./src/Assets/Images/Svgs/tournament_banner/calendar.svg",
	"./Svgs/tournament_banner/check_icon.svg": "./src/Assets/Images/Svgs/tournament_banner/check_icon.svg",
	"./Svgs/tournament_banner/corner_prize.svg": "./src/Assets/Images/Svgs/tournament_banner/corner_prize.svg",
	"./Svgs/tournament_banner/corner_prize_mobile.svg": "./src/Assets/Images/Svgs/tournament_banner/corner_prize_mobile.svg",
	"./Svgs/tournament_banner/currency-circle.svg": "./src/Assets/Images/Svgs/tournament_banner/currency-circle.svg",
	"./Svgs/tournament_banner/detail_pattern.svg": "./src/Assets/Images/Svgs/tournament_banner/detail_pattern.svg",
	"./Svgs/tournament_banner/gukesh.svg": "./src/Assets/Images/Svgs/tournament_banner/gukesh.svg",
	"./Svgs/tournament_banner/hat.svg": "./src/Assets/Images/Svgs/tournament_banner/hat.svg",
	"./Svgs/tournament_banner/image_1.svg": "./src/Assets/Images/Svgs/tournament_banner/image_1.svg",
	"./Svgs/tournament_banner/image_2.svg": "./src/Assets/Images/Svgs/tournament_banner/image_2.svg",
	"./Svgs/tournament_banner/image_3.svg": "./src/Assets/Images/Svgs/tournament_banner/image_3.svg",
	"./Svgs/tournament_banner/onboarding_tournament.svg": "./src/Assets/Images/Svgs/tournament_banner/onboarding_tournament.svg",
	"./Svgs/tournament_banner/puzzle.svg": "./src/Assets/Images/Svgs/tournament_banner/puzzle.svg",
	"./Svgs/tournament_banner/yellowBg.svg": "./src/Assets/Images/Svgs/tournament_banner/yellowBg.svg",
	"./Svgs/tournament_friends.svg": "./src/Assets/Images/Svgs/tournament_friends.svg",
	"./Svgs/trend-up-01.svg": "./src/Assets/Images/Svgs/trend-up-01.svg",
	"./Svgs/union.svg": "./src/Assets/Images/Svgs/union.svg",
	"./Svgs/userIcon.svg": "./src/Assets/Images/Svgs/userIcon.svg",
	"./Svgs/winBattleIcon.svg": "./src/Assets/Images/Svgs/winBattleIcon.svg",
	"./Svgs/wrong.svg": "./src/Assets/Images/Svgs/wrong.svg",
	"./Svgs/yellow.svg": "./src/Assets/Images/Svgs/yellow.svg",
	"./Svgs/yellowleft.svg": "./src/Assets/Images/Svgs/yellowleft.svg",
	"./Svgs/yellowright.svg": "./src/Assets/Images/Svgs/yellowright.svg",
	"./Svgs/zero_assessments_state.svg": "./src/Assets/Images/Svgs/zero_assessments_state.svg",
	"./Tournaments/no_pairing.svg": "./src/Assets/Images/Tournaments/no_pairing.svg",
	"./Tournaments/no_standing.svg": "./src/Assets/Images/Tournaments/no_standing.svg",
	"./Tournaments/no_tournament_found.svg": "./src/Assets/Images/Tournaments/no_tournament_found.svg",
	"./Workbook/WorkbookEmptyPage.svg": "./src/Assets/Images/Workbook/WorkbookEmptyPage.svg",
	"./ZoomBg/csoc_zoom_bg.png": "./src/Assets/Images/ZoomBg/csoc_zoom_bg.png",
	"./ZoomBg/csoc_zoom_bg.svg": "./src/Assets/Images/ZoomBg/csoc_zoom_bg.svg",
	"./bishop.png": "./src/Assets/Images/bishop.png",
	"./cursor-click.svg": "./src/Assets/Images/cursor-click.svg",
	"./glyphs/thumbsdown.svg": "./src/Assets/Images/glyphs/thumbsdown.svg",
	"./glyphs/thumbsup.svg": "./src/Assets/Images/glyphs/thumbsup.svg",
	"./glyphs/tick.svg": "./src/Assets/Images/glyphs/tick.svg",
	"./gukesh_banner_img.png": "./src/Assets/Images/gukesh_banner_img.png",
	"./gukesh_banner_mobile.png": "./src/Assets/Images/gukesh_banner_mobile.png",
	"./hide.svg": "./src/Assets/Images/hide.svg",
	"./icons/Rematch.png": "./src/Assets/Images/icons/Rematch.png",
	"./icons/Rematch@2x.png": "./src/Assets/Images/icons/Rematch@2x.png",
	"./icons/Rematch@3x.png": "./src/Assets/Images/icons/Rematch@3x.png",
	"./icons/close.png": "./src/Assets/Images/icons/close.png",
	"./icons/tick.png": "./src/Assets/Images/icons/tick.png",
	"./icons/tick@2x.png": "./src/Assets/Images/icons/tick@2x.png",
	"./icons/tick@3x.png": "./src/Assets/Images/icons/tick@3x.png",
	"./lock.png": "./src/Assets/Images/lock.png",
	"./pawn.png": "./src/Assets/Images/pawn.png",
	"./png/PRO.png": "./src/Assets/Images/png/PRO.png",
	"./png/abort.png": "./src/Assets/Images/png/abort.png",
	"./png/back_arrow.png": "./src/Assets/Images/png/back_arrow.png",
	"./png/badge.png": "./src/Assets/Images/png/badge.png",
	"./png/beginners_curve.png": "./src/Assets/Images/png/beginners_curve.png",
	"./png/black_box.png": "./src/Assets/Images/png/black_box.png",
	"./png/black_color.png": "./src/Assets/Images/png/black_color.png",
	"./png/black_rook.png": "./src/Assets/Images/png/black_rook.png",
	"./png/book-closed.png": "./src/Assets/Images/png/book-closed.png",
	"./png/book.png": "./src/Assets/Images/png/book.png",
	"./png/book_dummy.png": "./src/Assets/Images/png/book_dummy.png",
	"./png/bottom_left_square.png": "./src/Assets/Images/png/bottom_left_square.png",
	"./png/bottom_right_square.png": "./src/Assets/Images/png/bottom_right_square.png",
	"./png/casual_player.png": "./src/Assets/Images/png/casual_player.png",
	"./png/challenge.png": "./src/Assets/Images/png/challenge.png",
	"./png/challenge@2x.png": "./src/Assets/Images/png/challenge@2x.png",
	"./png/challenge@3x.png": "./src/Assets/Images/png/challenge@3x.png",
	"./png/chapter.png": "./src/Assets/Images/png/chapter.png",
	"./png/chart.png": "./src/Assets/Images/png/chart.png",
	"./png/chat.png": "./src/Assets/Images/png/chat.png",
	"./png/checkmark.png": "./src/Assets/Images/png/checkmark.png",
	"./png/chess_events.png": "./src/Assets/Images/png/chess_events.png",
	"./png/chess_footer_background.png": "./src/Assets/Images/png/chess_footer_background.png",
	"./png/chessboard_left_part_large.png": "./src/Assets/Images/png/chessboard_left_part_large.png",
	"./png/chessboard_part_left.png": "./src/Assets/Images/png/chessboard_part_left.png",
	"./png/chessboard_part_placeholder.png": "./src/Assets/Images/png/chessboard_part_placeholder.png",
	"./png/chessboard_part_right.png": "./src/Assets/Images/png/chessboard_part_right.png",
	"./png/chessboard_right_part_large.png": "./src/Assets/Images/png/chessboard_right_part_large.png",
	"./png/circle_chess_logo.png": "./src/Assets/Images/png/circle_chess_logo.png",
	"./png/circle_chess_logo_black.png": "./src/Assets/Images/png/circle_chess_logo_black.png",
	"./png/circlechess_screenshot.png": "./src/Assets/Images/png/circlechess_screenshot.png",
	"./png/custom_rules_icon.png": "./src/Assets/Images/png/custom_rules_icon.png",
	"./png/custom_rules_modal.png": "./src/Assets/Images/png/custom_rules_modal.png",
	"./png/defeat_result.png": "./src/Assets/Images/png/defeat_result.png",
	"./png/delete.png": "./src/Assets/Images/png/delete.png",
	"./png/diagonal_chess_part.png": "./src/Assets/Images/png/diagonal_chess_part.png",
	"./png/double_arrow_up.png": "./src/Assets/Images/png/double_arrow_up.png",
	"./png/draw.png": "./src/Assets/Images/png/draw.png",
	"./png/draw_result.png": "./src/Assets/Images/png/draw_result.png",
	"./png/dropdown.png": "./src/Assets/Images/png/dropdown.png",
	"./png/elevate.png": "./src/Assets/Images/png/elevate.png",
	"./png/empty_book.png": "./src/Assets/Images/png/empty_book.png",
	"./png/empty_result.png": "./src/Assets/Images/png/empty_result.png",
	"./png/endgame.png": "./src/Assets/Images/png/endgame.png",
	"./png/engine.png": "./src/Assets/Images/png/engine.png",
	"./png/eye.png": "./src/Assets/Images/png/eye.png",
	"./png/file.png": "./src/Assets/Images/png/file.png",
	"./png/gamesummary.png": "./src/Assets/Images/png/gamesummary.png",
	"./png/go_back.png": "./src/Assets/Images/png/go_back.png",
	"./png/home.png": "./src/Assets/Images/png/home.png",
	"./png/intermediate.png": "./src/Assets/Images/png/intermediate.png",
	"./png/late_guess.png": "./src/Assets/Images/png/late_guess.png",
	"./png/learning.png": "./src/Assets/Images/png/learning.png",
	"./png/level_unit_empty.png": "./src/Assets/Images/png/level_unit_empty.png",
	"./png/level_unit_filled.png": "./src/Assets/Images/png/level_unit_filled.png",
	"./png/master.png": "./src/Assets/Images/png/master.png",
	"./png/middlegame.png": "./src/Assets/Images/png/middlegame.png",
	"./png/mobileOne.png": "./src/Assets/Images/png/mobileOne.png",
	"./png/newGame.png": "./src/Assets/Images/png/newGame.png",
	"./png/opening.png": "./src/Assets/Images/png/opening.png",
	"./png/opening2.png": "./src/Assets/Images/png/opening2.png",
	"./png/organisation_trophy.png": "./src/Assets/Images/png/organisation_trophy.png",
	"./png/player.png": "./src/Assets/Images/png/player.png",
	"./png/random_color.png": "./src/Assets/Images/png/random_color.png",
	"./png/record_button.png": "./src/Assets/Images/png/record_button.png",
	"./png/refresh.png": "./src/Assets/Images/png/refresh.png",
	"./png/resign.png": "./src/Assets/Images/png/resign.png",
	"./png/review_game.png": "./src/Assets/Images/png/review_game.png",
	"./png/search.png": "./src/Assets/Images/png/search.png",
	"./png/settings.png": "./src/Assets/Images/png/settings.png",
	"./png/settings_close.png": "./src/Assets/Images/png/settings_close.png",
	"./png/shopping-bag.png": "./src/Assets/Images/png/shopping-bag.png",
	"./png/signup_assess.png": "./src/Assets/Images/png/signup_assess.png",
	"./png/signup_elevate.png": "./src/Assets/Images/png/signup_elevate.png",
	"./png/signup_play.png": "./src/Assets/Images/png/signup_play.png",
	"./png/square_background.png": "./src/Assets/Images/png/square_background.png",
	"./png/stockfish_settings.png": "./src/Assets/Images/png/stockfish_settings.png",
	"./png/stop_record.png": "./src/Assets/Images/png/stop_record.png",
	"./png/trash.png": "./src/Assets/Images/png/trash.png",
	"./png/upload.png": "./src/Assets/Images/png/upload.png",
	"./png/voice_process.png": "./src/Assets/Images/png/voice_process.png",
	"./png/whatsapp_say_hi.png": "./src/Assets/Images/png/whatsapp_say_hi.png",
	"./png/whatsapp_share.png": "./src/Assets/Images/png/whatsapp_share.png",
	"./png/white_box.png": "./src/Assets/Images/png/white_box.png",
	"./png/white_color.png": "./src/Assets/Images/png/white_color.png",
	"./png/white_rook.png": "./src/Assets/Images/png/white_rook.png",
	"./png/win_result.png": "./src/Assets/Images/png/win_result.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Assets/Images sync recursive ^\\.\\/.*$";